module.exports = __webpack_public_path__ + "static/img/frame 7.d0972dbd.png";